import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, AlertTriangle } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6" 
         style={{ backgroundColor: '#fdfcf5' }}>
      <div className="max-w-2xl w-full">
        {/* Carte principale */}
        <div className="bg-white border-4 p-8 text-center" 
             style={{ borderColor: '#e5e5e5', borderRadius: '0' }}>
          
          {/* Icône warning */}
          <div className="inline-flex items-center justify-center w-32 h-32 border-4 mb-6"
               style={{ backgroundColor: '#fed774', borderColor: '#fed774', borderRadius: '0' }}>
            <AlertTriangle className="text-gray-900" size={64} strokeWidth={3} />
          </div>

          {/* Code 404 */}
          <div className="text-9xl font-black mb-4"
               style={{ color: '#88b9c5' }}>
            404
          </div>

          {/* Message */}
          <div className="mb-2">
            <h1 className="text-2xl font-black text-gray-900 uppercase tracking-wider mb-3">
              Page non trouvée
            </h1>
            <p className="text-sm font-bold text-gray-600 uppercase tracking-wider">
              La page que vous recherchez n'existe pas ou a été déplacée
            </p>
          </div>

          {/* Boutons d'action */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <button
              onClick={() => navigate(-1)}
              className="px-6 py-4 border-4 font-black text-sm uppercase tracking-wider transition-all inline-flex items-center justify-center"
              style={{ borderColor: '#e5e5e5', borderRadius: '0' }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(-5px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour
            </button>

            <button
              onClick={() => navigate('/dashboard')}
              className="px-6 py-4 text-white border-4 font-black text-sm uppercase tracking-wider transition-all inline-flex items-center justify-center"
              style={{ backgroundColor: '#88b9c5', borderColor: '#88b9c5', borderRadius: '0' }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              <Home className="w-5 h-5 mr-2" />
              Tableau de bord
            </button>
          </div>
        </div>

        {/* Message d'aide */}
        <div className="mt-6 p-4 border-4 bg-white" 
             style={{ borderColor: '#e5e5e5', borderRadius: '0' }}>
          <p className="text-xs font-bold text-gray-600 text-center uppercase tracking-wider">
            Si le problème persiste, contactez le support technique
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
